import { CardContent } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import singleFrame from "../../../Assets/Images/Normal-User/Single-frame.png";
import applePayLogo from "../../../Assets/Images/Payment-img/Apple_Pay_logo.png";
import paytm from "../../../Assets/Images/Payment-img/Paytm_Logo.png";
import payoneerLogo from "../../../Assets/Images/Payment-img/Payoneer-Logo.wine.png";
import payPalLogo from "../../../Assets/Images/Payment-img/PayPal-Logo.wine.png";
import visaLogo from "../../../Assets/Images/Payment-img/Visa_Inc._logo.svg.png";
import { usePaytm } from "../../../CustomHooks/usePaytm";
import stripe from "../../../Assets/Images/Payment-img/strip.png";
import shurjoPay from "../../../Assets/Images/Payment-img/shurjo-pay.jpeg";

import "./PaymentModal.css";
import { useStripePayment } from "../../../CustomHooks/useStripePayment";
import StripeModal from "./StripeModal";
import { useShurjoPay } from "../../../CustomHooks/useShurjoPay";

const PaymentModal = (props) => {
  const { makePaytmPayment, paymentBuffer } = usePaytm({
    amount: props?.fee,
    redirectTo: "activities",
    type: props?.type,
    event_id: props?.eventId,
  });

  const {
    stripeMakePayment,
    stripeBuffer,
    clientSecret,
    publicKey,
    error,
    stripeModalShow,
    setStripeModalShow,
  } = useStripePayment({
    amount: props?.fee,
    event_type: props?.type,
    event_id: props?.eventId,
  });

  const { shurjoPayMakePayment, shurjoBuffer } = useShurjoPay({
    amount: props?.fee,
    event_type: props?.type,
    event_id: props?.eventId,
    client_ip: "web"
  });


  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="modalBody modalBodyStyle">
          <Card style={{ backgroundColor: "#343434" }} sx={{ minWidth: 275 }}>
            <div className="d-flex justify-content-end p-2">
              <button
                onClick={props.onHide}
                className="closeNotificationDrop text-center"
              >
                X
              </button>
            </div>

            <CardContent>
              <div className="text-center image-middle">
                <img className="singleFrame-style" src={singleFrame} alt="" />
                <h3 className="centered">Choose payment method</h3>
              </div>

              <div>
                <center>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      paddingTop: "50px",
                      paddingBottom: "50px",
                      minHeight: "200px",
                    }}
                  >
                    {stripeBuffer || paymentBuffer ? (
                      <div class="spinner-border text-warning" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    ) : (
                      <>
                        <div
                          className="item"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            makePaytmPayment();
                          }}
                        >
                          <img
                            src={paytm}
                            alt=""
                            className="img-fluid payment-img"
                          />
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          className="item"
                          onClick={() => stripeMakePayment()}
                        >
                          <img
                            src={stripe}
                            alt=""
                            className="img-fluid payment-img"
                          />
                        </div>

                        <div
                          style={{ cursor: "pointer" }}
                          className="item"

                          onClick={() => shurjoPayMakePayment()}
                        >
                          <img
                            src={shurjoPay}
                            alt=""
                            className="img-fluid payment-img"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </center>
              </div>
            </CardContent>
          </Card>
        </Modal.Body>
      </Modal>
      <StripeModal
        show={stripeModalShow}
        onHide={() => setStripeModalShow(false)}
        amount={props?.fee}
        event_id={props?.eventId}
        event_type={props?.type}
        clientSecret={clientSecret}
        publicKey={publicKey}
      />
    </>
  );
};

export default PaymentModal;
